/**
 * Play Toggle
 */

const imgs = document.querySelectorAll('.img-block img');
const fullPage = document.querySelector('#fullScreenImg');
const modal = document.getElementById('imgModal');
const body = document.querySelector('body');
const nextImg = document.getElementById('nextImg');
const prevImg = document.getElementById('prevImg');

function openInModal() {
    const imgSrc = this.src;
    fullPage.src = allSrcs[allSrcs.indexOf(imgSrc)];
    modal.classList.add('modal-open');
    body.classList.add('no-scroll');
}

imgs.forEach(img => {
    img.addEventListener('click', openInModal);
});

// full image slider
const allSrcs = Array.from(imgs, img => img.src);
var i = 0;

function nextItem() {
    i = i + 1;
    i = i % allSrcs.length;
    return allSrcs[i];
}
function prevItem() {
    if (i === 0) {
        i = allSrcs.length;
    }
    i = i - 1;
    return allSrcs[i];
}
nextImg.addEventListener('click', function() {
    fullPage.src = nextItem();
});
prevImg.addEventListener('click', function() {
    fullPage.src = prevItem();
});


const modals = document.querySelectorAll('.fancybox-modal');
modals.forEach(img => {
    img.addEventListener('click', openInModal);
});


const closeBtn = document.getElementById('imageClose');
closeBtn.addEventListener('click', function() {
    modal.classList.remove('modal-open');
    body.classList.remove('no-scroll');
});